import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearState } from "react-admin";
import LoginLayout from "./LoginLayout";
import { Typography } from "@material-ui/core";
import { localStorageService } from "../util/localStorageService";

const FrontChannelLogout = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearState());
    localStorageService.clearRedirect();
  }, [dispatch]);

  return (
    <LoginLayout>
      <Typography variant="body1">Logging out...</Typography>
    </LoginLayout>
  );
};

export default FrontChannelLogout;
